const getSpecialCharacters = (opacity: number) => ({
    '|': `rgba(19, 170, 95, ${opacity})`, // groen, korte klank
    '#': `rgba(252, 185, 52, ${opacity})`, // oranje (licht), lange klank
    '^': `rgba(221, 40, 79, ${opacity})`, // rood, tweetekenklank
    '~': `rgba(255, 255, 255, ${opacity})`, // zwart, bijzondere klank met punt
    // eslint-disable-next-line prettier/prettier
    '_': `rgba(5, 120, 206, ${opacity})`, // blauw, bijzondere klank met liggende streepje
    '{': `rgba(5, 120, 206, ${opacity})`, // blauw, Medeklinkers
    '}': `rgba(246, 107, 36, ${opacity})`, // oranje (donker), stomme klank
    '[': `rgba(189, 204, 212, ${opacity})`, // grijs
});

export const highlightString = (string: string) => {
    const specialCharacters = getSpecialCharacters(0.2);

    let newText = string;

    for (const [char, cls] of Object.entries(specialCharacters)) {
        const regex = new RegExp(`\\${char}(.+?)\\${char}`, 'g');
        newText = newText.replace(
            regex,
            `<span style="background-color: ${cls}; border: ${
                char === '~'
                    ? '1.5px solid rgba(0,0,0,0.2)'
                    : '1.5px solid transparent'
            }">$1</span>`
        );
    }

    return newText;
};

export const getHighlightBackground = (char: string) => {
    const specialCharacters = getSpecialCharacters(1);

    // @ts-ignore
    return specialCharacters[char];
};
